import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/shop/page.tsx");
